export const KOPY_PAGES_THEME_COLORS = [
	"pink",
	"monochrome",
	"turquoise",
	"purple",
	"blue",
	"green",
	"yellow",
	"orange",
	"red",
	"gray",
]

const AUTOSTORE_THEME_NAMES = {
	"beauty-and-cosmetics": "autostore-fashion",
	"fashion-and-accessories": "autostore-fashion",
	"home-and-kitchen": "autostore-home",
	pets: "autostore-pets",
	"sport-and-fitness": "autostore-sport",
	"tech-and-gadgets": "autostore-tech",
}

// Themes installed via /api/themes/install are named with spaces
// ("sport and fitness") while AUTOSTORE_THEME_NAMES keys are dashed slugs,
// so collapse whitespace to dashes before matching
const getThemeSearchText = (theme) =>
	[theme?.title, theme?.name]
		.filter(Boolean)
		.join(" ")
		.toLowerCase()
		.replace(/\s+/g, "-")

export const getKopyPagesThemeColorFromTitle = (title) => {
	const normalizedTitle = String(title || "").toLowerCase()

	return KOPY_PAGES_THEME_COLORS.find((color) => {
		const colorMatcher = new RegExp(
			`(^|[^a-z0-9])${color}([^a-z0-9]|$)`,
			"i",
		)

		return colorMatcher.test(normalizedTitle)
	})
}

export const canModifyKopyPagesThemeColors = (theme) => {
	const titleColor = getKopyPagesThemeColorFromTitle(theme?.title)

	return Boolean(titleColor && theme?.themePalette)
}

export const getAutostorePagesThemeName = (theme) => {
	const searchText = getThemeSearchText(theme)

	for (const [themeSlug, pagesThemeName] of Object.entries(
		AUTOSTORE_THEME_NAMES,
	)) {
		if (searchText.includes(themeSlug)) return pagesThemeName
	}

	return null
}

export const isAutostoreSpecificTheme = (theme) =>
	Boolean(
		getAutostorePagesThemeName(theme) &&
		!getKopyPagesThemeColorFromTitle(theme?.title),
	)

export const isAutostoreDefaultThemeSelection = (themeName) =>
	typeof themeName === "string" && themeName.startsWith("autostore-")
